/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProductTypeEnum {
  Menu = 'Menu',
  Schedule = 'Schedule'
}
